import type { ReactElement } from "react";
import type { StyleProp, ViewStyle } from "react-native";
export type ZoomLinkProps = {
  href: string;
  /** Opens `href`; on iOS the link itself navigates instead. */
  onOpen: () => void;
  onPressStart?: () => void;
  children: (onPress: () => void) => ReactElement;
};
export const zoomHidesSource = () => false;
export const ZoomLink = ({
  onOpen,
  onPressStart,
  children
}: ZoomLinkProps) => children(() => {
  onPressStart?.();
  onOpen();
});
export type ZoomTargetProps = {
  style: StyleProp<ViewStyle>;
};
export const ZoomTarget = (_props: ZoomTargetProps) => null;